export function calculateRemainingDays(toDate: string): number {
    const today = new Date();
    const targetDate = new Date(toDate);
    const timeDifference = targetDate.getTime() - today.getTime();
    return Math.ceil(timeDifference / (1000 * 3600 * 24));
}
